import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import FilterContainerStyled from './FilterContainerStyled';
import useMediaQuery from '../../custom-hooks/useMediaQuery';
import { device } from '../../../utils/styled-component-mixins';

const SearchFilters = ({
  isFiltersShown,
  filters,
  selectedFilter,
  setIsFiltersShown,
  updateSelectedFilter,
  clearFiltersButtonText,
  clearFiltersFunction,
  mobileFiltersLabel,
  seeResultsTextMobile,
  totalResults
}) => {
  const isDesktop = useMediaQuery(device.desktop);
  const filterContainerRef = useRef(null);
  const [isFirstRender, setIsFirstRender] = useState(true);
  const [seeResultsButtonText, setSeeResultsButtonText] = useState('');

  const formatFilterCodeName = (filterCodeName) => filterCodeName.split('.')[1];

  const formatResultsTextString = (count, string) => string?.replace('{0}', count);

  useEffect(() => {
    if (window.innerWidth < 992) {
      // handle filter menu toggle animation
      const body = document.querySelector('body');

      if (!isFiltersShown || isFirstRender) {
        const timeOut = isFirstRender ? 0 : 350;
        setTimeout(() => {
          filterContainerRef.current.classList.add('hidden');
        }, timeOut);
        filterContainerRef.current.classList.remove('transition-in');
        filterContainerRef.current.classList.add('transition-out');
        body.style.overflow = 'auto';
        body.style.position = 'relative';

        setIsFirstRender(false);
      } else if (isFiltersShown) {
        filterContainerRef.current.classList.remove('hidden');
        filterContainerRef.current.classList.remove('transition-out');
        filterContainerRef.current.classList.add('transition-in');
        body.style.overflow = 'hidden';
        body.style.position = 'fixed';
      }
    } else {
      filterContainerRef.current.classList.remove('hidden');
    }
  }, [isFiltersShown, isDesktop]);

  useEffect(() => {
    setSeeResultsButtonText(formatResultsTextString(totalResults, seeResultsTextMobile));
  }, [totalResults]);

  return (
    <FilterContainerStyled className="col-md-3">
      <div ref={filterContainerRef} id="search-filters" className="filters-container hidden">
        <fieldset aria-live="polite">
          <legend className={classNames('filter-legend', { 'sr-only': isDesktop })}>
            {mobileFiltersLabel}
          </legend>
          {!isDesktop && (
            <button
              className="mobile-filter-close"
              aria-label="close filters"
              aria-haspopup="true"
              aria-expanded="true"
              onClick={() => setIsFiltersShown(!isFiltersShown)}
            >
              <span className="material-icons-round">close</span>
            </button>
          )}
          <div className="filters-wrapper">
            {filters.map((filter) => (
              <div
                className={classNames('filter-group', { 'no-results': filter.count === 0 })}
                key={filter.codeName}
              >
                <input
                  checked={selectedFilter === formatFilterCodeName(filter.codeName)}
                  onChange={() => updateSelectedFilter(formatFilterCodeName(filter.codeName))}
                  type="checkbox"
                  id={filter.codeName}
                  name="filter"
                  value={filter.codeName}
                  disabled={filter.count === 0}
                />
                <label htmlFor={filter.codeName}>
                  {filter.displayName}
                  <span className="filter-count">({filter.count})</span>
                </label>
              </div>
            ))}
          </div>
          {!isDesktop && (
            <div className="mobile-controls">
              <ButtonLink
                className="clear-filters-btn-mobile"
                isButtonTag={true}
                onClickFunction={() => clearFiltersFunction()}
                size="small"
                text={clearFiltersButtonText}
                theme="light"
                type="secondary"
                useWidgetIdWrapper={false}
                isDisabled={!selectedFilter}
              />
              <ButtonLink
                className="clear-filters-btn-desktop"
                isButtonTag={true}
                onClickFunction={() => setIsFiltersShown(!isFiltersShown)}
                size="small"
                text={seeResultsButtonText}
                theme="light"
                type="primary"
                useWidgetIdWrapper={false}
              />
            </div>
          )}
        </fieldset>
      </div>
    </FilterContainerStyled>
  );
};

export default SearchFilters;
